"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@common/components/Button"));
var SelectDropdown_1 = __importDefault(require("@common/components/SelectDropdown"));
var _store_1 = require("@store");
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var DraggableDecisionPriorityItem_1 = __importDefault(require("./DraggableDecisionPriorityItem"));
var orchestrationSlice_1 = require("../../state/orchestrationSlice");
var orchestrationArticleLink = 'https://help.besedo.com/18062-automation/how_automation_works';
function Orchestration(props) {
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var getDecisionPriorityLabel = function (decision) {
        switch (decision) {
            case 'approve':
                return t('settings:ORCHESTRATION.ACTION_PRIORITY.APPROVE');
            case 'refuse':
                return t('settings:ORCHESTRATION.ACTION_PRIORITY.REFUSE');
            case 'manual':
                return t('settings:ORCHESTRATION.ACTION_PRIORITY.SEND_TO_MANUAL');
            default:
                return '';
        }
    };
    var defaultDecisionPriorities = [
        { label: getDecisionPriorityLabel('approve'), value: 'approve' },
        { label: getDecisionPriorityLabel('refuse'), value: 'refuse' },
        { label: getDecisionPriorityLabel('manual'), value: 'manual' },
    ];
    var defaultDecisionOptions = [
        { label: t('settings:ORCHESTRATION.DEFAULT_MODERATION_OUTCOME.APPROVE'), id: 'approve' },
        { label: t('settings:ORCHESTRATION.DEFAULT_MODERATION_OUTCOME.REFUSE'), id: 'refuse' },
        { label: t('settings:ORCHESTRATION.DEFAULT_MODERATION_OUTCOME.SEND_TO_MANUAL'), id: 'manual' },
    ];
    var externalModerationEnabledOptions = [
        { id: 'false', text: t('settings:ORCHESTRATION.MANUAL_MODERATION_LOCATION.IN_IMPLIO') },
        { id: 'true', text: t('settings:ORCHESTRATION.MANUAL_MODERATION_LOCATION.EXTERNAL') },
    ];
    var domain = props.domain;
    var dispatch = (0, _store_1.useAppDispatch)();
    var orchestrationSettings = (0, react_redux_1.useSelector)(orchestrationSlice_1.orchestrationSettingsSelector);
    var loading = (0, react_redux_1.useSelector)(orchestrationSlice_1.loadingSelector);
    var error = (0, react_redux_1.useSelector)(orchestrationSlice_1.errorSelector);
    var _a = __read((0, react_1.useState)(defaultDecisionPriorities), 2), decisionPriorities = _a[0], setDecisionPriorities = _a[1];
    var _b = __read((0, react_1.useState)('approve'), 2), defaultDecision = _b[0], setDefaultDecision = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), externalModerationEnabled = _c[0], setExternalModerationEnabled = _c[1];
    var saveChanges = function () {
        var formData = {
            orchestration: decisionPriorities.map(function (d, index) { return ({ value: d.value, priority: index + 1 }); }),
            defaultDecision: defaultDecision,
            externalModerationEnabled: externalModerationEnabled,
        };
        dispatch((0, orchestrationSlice_1.persistOrchestrationSettings)(domain, formData));
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, orchestrationSlice_1.fetchOrchestrationSettings)(domain));
    }, [domain]);
    (0, react_1.useEffect)(function () {
        if (orchestrationSettings) {
            var defaultDecision_1 = orchestrationSettings.defaultDecision, externalModerationEnabled_1 = orchestrationSettings.externalModerationEnabled, orchestration = orchestrationSettings.orchestration;
            var decisionPrioritiesData = orchestration.map(function (d) { return (__assign({ label: getDecisionPriorityLabel(d.value) }, d)); });
            setDecisionPriorities(decisionPrioritiesData);
            setDefaultDecision(defaultDecision_1);
            setExternalModerationEnabled(externalModerationEnabled_1);
        }
    }, [orchestrationSettings]);
    var handleDefaultDecisionChange = function (id) {
        setDefaultDecision(id);
    };
    var handleModerationLocation = function (id) {
        var isTrue = id === 'true';
        setExternalModerationEnabled(isTrue);
    };
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        if (!destination)
            return;
        var newDecisionPriorities = Array.from(decisionPriorities);
        var _a = __read(newDecisionPriorities.splice(source.index, 1), 1), newOrder = _a[0];
        newDecisionPriorities.splice(destination.index, 0, newOrder);
        setDecisionPriorities(newDecisionPriorities);
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "orchestration-settings" },
            react_1.default.createElement("div", { className: "title" }, t('settings:ORCHESTRATION.TITLE')),
            react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "ORCHESTRATION.DESCRIPTION", components: [react_1.default.createElement("a", { className: "eva-link-primary", href: orchestrationArticleLink, target: "_blank", rel: "noreferrer" })] }),
            react_1.default.createElement("div", { className: "orchestration-settings-section" },
                react_1.default.createElement("h3", { className: "section-title" }, t('settings:ORCHESTRATION.ACTION_PRIORITY.TITLE')),
                react_1.default.createElement("div", { className: "section-description" }, t('settings:ORCHESTRATION.ACTION_PRIORITY.DESCRIPTION')),
                react_1.default.createElement("div", { className: "section-label" }, t('settings:ORCHESTRATION.ACTION_PRIORITY.LABEL')),
                react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd },
                    react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "decisionPriorities" }, function (provided) { return (react_1.default.createElement("div", __assign({ className: "decision-priority" }, provided.droppableProps, { ref: provided.innerRef }),
                        decisionPriorities.map(function (decisionPriorityItem, index) { return (react_1.default.createElement(DraggableDecisionPriorityItem_1.default, { decisionPriorityItem: decisionPriorityItem, index: index })); }),
                        provided.placeholder)); }))),
            react_1.default.createElement("div", { className: "orchestration-settings-section" },
                react_1.default.createElement("h3", { className: "section-title" },
                    " ",
                    t('settings:ORCHESTRATION.DEFAULT_MODERATION_OUTCOME.TITLE'),
                    " "),
                react_1.default.createElement("div", { className: "section-label" },
                    react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "ORCHESTRATION.DEFAULT_MODERATION_OUTCOME.DESCRIPTION" })),
                react_1.default.createElement(SelectDropdown_1.default, { items: defaultDecisionOptions.map(function (i) { return ({ id: i.id, text: i.label }); }), selectedItemId: defaultDecision, onItemSelected: handleDefaultDecisionChange })),
            react_1.default.createElement("div", { className: "orchestration-settings-section" },
                react_1.default.createElement("h3", { className: "section-title" },
                    " ",
                    t('settings:ORCHESTRATION.MANUAL_MODERATION_LOCATION.TITLE')),
                react_1.default.createElement("div", { className: "section-label" }, t('settings:ORCHESTRATION.MANUAL_MODERATION_LOCATION.DESCRIPTION')),
                react_1.default.createElement(SelectDropdown_1.default, { items: externalModerationEnabledOptions.map(function (i) { return ({ id: i.id, text: i.text }); }), selectedItemId: String(externalModerationEnabled), onItemSelected: handleModerationLocation }),
                react_1.default.createElement("div", { className: "section-description" }, externalModerationEnabled ? (react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "ORCHESTRATION.MANUAL_MODERATION_LOCATION.EXTERNAL_BELOW_LABEL" })) : (react_1.default.createElement(react_i18next_1.Trans, { ns: "settings", i18nKey: "ORCHESTRATION.MANUAL_MODERATION_LOCATION.IN_IMPLIO_BELOW_LABEL" })))),
            react_1.default.createElement("div", { className: "warning" },
                react_1.default.createElement("span", { className: "implioicons-warning" }),
                react_1.default.createElement("span", { className: "section-description" },
                    " ",
                    t('settings:ORCHESTRATION.WARNING'),
                    " ")),
            react_1.default.createElement(Button_1.default, { text: t('settings:ORCHESTRATION.SAVE_BUTTON'), disabled: loading || Boolean(error), onClick: saveChanges }))));
}
exports.default = Orchestration;
